/**
 * Stage AJAX functions
 */

/**
 * Delete a stage
 * @param {number} stageId - The stage ID to delete
 * @returns {Promise}
 */
export function deleteStage(stageId) {
	const formData = new FormData();
	formData.append('action', 'wpcore_delete_stage');
	formData.append('nonce', wpcore.nonce);
	formData.append('stage_id', stageId);

	return fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				return data.data;
			} else {
				throw new Error(data.data?.message || wpcore.direct_t({ en: 'Failed to delete stage', fr: 'Échec de la suppression de l\'étape' }));
			}
		});
}

/**
 * Save stages
 * @param {FormData} formData - Form data with stages
 * @returns {Promise}
 */
export function saveStages(formData) {
	formData.append('action', 'save_stages');

	return fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				return data.data;
			} else {
				throw new Error(data.data?.message || wpcore.direct_t({ en: 'Failed to save stages', fr: 'Échec de l\'enregistrement des étapes' }));
			}
		});
}

/**
 * Send journey email
 * @param {FormData} formData - Form data with journey info
 * @returns {Promise}
 */
export function sendJourneyEmail(formData) {
	formData.append('action', 'send_journey_email');

	return fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				return data.data;
			} else {
				throw new Error(data.data?.message || wpcore.direct_t({ en: 'Failed to send email', fr: 'Échec de l\'envoi de l\'e-mail' }));
			}
		});
}

/**
 * Add a new stage
 * @param {FormData} formData - Form data with stage info
 * @returns {Promise}
 */
export function addStage(formData) {
	formData.append('action', 'wpcore_add_stage');
	formData.append('nonce', wpcore.nonce);

	return fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				return data.data;
			} else {
				throw new Error(data.data?.message || wpcore.direct_t({ en: 'Failed to add stage', fr: 'Échec de l\'ajout de l\'étape' }));
			}
		});
}
